import { Intent, Model } from '../../../../../../typesOld'
import { isIntent } from '../../../../../../../../features/nlpIntentList'
import { NlpModel } from '@feedyou/schema'
import { TrainingSelectOptions } from '../../IntentSelect'

export function getModelForIntentId(intentId: string, models: Model[]): NlpModel | undefined {
  return models.find((model: Model) =>
    model?.intents?.some(intent => isIntent(intent) && intent.id === intentId)
  )
}

export function getSelectOptions(models: Model[]): TrainingSelectOptions {
  return models
    ?.filter(model => model?.intents)
    ?.map(model => {
      return {
        label: model.id,
        options: model?.intents?.filter(isIntent)?.map(intentToOption) ?? []
      }
    }) as TrainingSelectOptions
}

const intentToOption = (intent: Intent) => {
  return {
    value: intent?.id,
    label: intent?.name
  }
}
